<template>
  <div class="login_content">
    <div class="login_Box">
      <h3>{{baseName}}管理后台</h3>
      <el-form
        ref="loginRef"
        :model="loginForm"
        :rules="loginRules"
        label-width="60px"
        :hide-required-asterisk="true"
      >
        <el-form-item label="账号 :" prop="loginName">
          <el-input v-model="loginForm.loginName"></el-input>
        </el-form-item>
        <el-form-item label="密码 :" prop="password">
          <el-input type="password" v-model="loginForm.password"></el-input>
        </el-form-item>
        <div class="loginBtn">
          <el-button type="primary" @click="login">登录</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { baseName } from '@/base.js'
import { login } from '@/API/login'
import Cookies from 'js-cookie'
export default {
  name: 'login',
  data() {
    return {
      baseName: baseName,
      // 表单数据对象
      loginForm: {
        loginName: '',
        password: ''
      },
      // 表单验证规则
      loginRules: {
        loginName: [{ required: true, message: '请输入账号', trigger: 'blur' }, { min: 3, max: 18, message: '长度在3 到 18 个字符', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.keyupSubmit()
  },
  methods: {
    // 登录按钮点击触发
    login() {
      this.$refs.loginRef.validate(async valid => {
        if (!valid) return
        // 发送请求验证用户账号密码是否正确
        const { data: res } = await login(this.loginForm)
        if (res.code !== 200) return this.$message.error(res.message)
        // window.sessionStorage.setItem('token', res.data.accessToken.accessToken)
        // window.sessionStorage.setItem('nickname', res.data.nickname)
        // window.sessionStorage.setItem('cellphone', res.data.cellphone)
        Cookies.set('token', res.data.accessToken.accessToken)
        Cookies.set('nickname', res.data.nickname)
        Cookies.set('cellphone', res.data.cellphone)
        this.$router.push('/home')
      })
    },
    // 回车键按下监听事件
    keyupSubmit() {
      document.onkeydown = e => {
        let key = window.event.keyCode
        if (key === 13) {
          this.login()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_content {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #EEEEE0;
  background-image: url("/static/image/default/login-bg-common.png");
  background-repeat: no-repeat;
  background-size: cover;
  .login_Box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 250px;
    border-radius: 5px;
    background-color: rgba(204, 204, 204, 0.8);
    z-index: 999;
    h3 {
      margin: 10px;
      padding: 0;
      font-size: 30px;
      text-align: center;
      letter-spacing: 8px;
    }
    .el-form {
      margin-top: 20px;
      // margin-right: 30px;
      .el-input {
        width: 310px;
      }
      .loginBtn {
        text-align: center;
      }
    }
  }
}
.login_content:after{
  content: "";
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background: inherit;
  filter: blur(5px);
  z-index: 2;
}
</style>
